// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Section_elSection__ibxti {\n  margin-bottom: 16px; }\n\n.Section_vinWrapper__2pfMa {\n  position: relative; }\n\n.Section_warningModal__xaCgs {\n  width: 450px !important; }\n", ""]);
// Exports
exports.locals = {
	"elSection": "Section_elSection__ibxti",
	"vinWrapper": "Section_vinWrapper__2pfMa",
	"warningModal": "Section_warningModal__xaCgs"
};
module.exports = exports;
